// Currency conversion and formatting utilities
const USD_TO_INR = 83; // Conversion rate: 1 USD = 83 INR

/**
 * Convert USD to INR
 * @param {number} usdAmount - Amount in USD
 * @returns {number} Amount in INR
 */
export const convertToINR = (usdAmount) => {
  return Math.round(usdAmount * USD_TO_INR);
};

/**
 * Format price in INR with currency symbol
 * @param {number} amount - Amount in INR
 * @returns {string} Formatted price with ₹ symbol
 */
export const formatINR = (amount) => {
  return `₹${amount.toLocaleString('en-IN')}`;
};

/**
 * Convert USD to INR and format
 * @param {number} usdAmount - Amount in USD
 * @returns {string} Formatted price in INR with ₹ symbol
 */
export const convertAndFormatINR = (usdAmount) => {
  const inrAmount = convertToINR(usdAmount);
  return formatINR(inrAmount);
};
